import { useEffect, useState } from 'react'
import PlanSummary from '../../../components/companyModal/CompanyModal';
import { useDispatch, useSelector } from 'react-redux';
import { getPayoutListAction } from '../../../actions/advisor';
import ReactPaginate from 'react-paginate';
import Currency from '../../../components/currency';
import CurrencyFormat from '../../../components/currencyFormat/currencyFormat';
import CreatePayment from '../../chatPage/CreatePayment';

export default function PayoutListComponent() {
    const dispatch = useDispatch()
    const { payoutList, payoutListCount } = useSelector(state => state.advisor);
    const [tab, setTab] = useState('estimated')
    const [expandedRow, setExpandedRow] = useState(null);
    const limit = 10
    const [page, setPage] = useState(1)
    const [activePage, setActivePage] = useState(0)
    const [paymentLinkModal, setPaymentLinkModal] = useState(false);

    const toggleRow = (id) => {
        setExpandedRow(expandedRow === id ? null : id);
    };


    const handlePageClick = (e) => {
        const selectedPage = e.selected;
        setActivePage(selectedPage);
        setPage(selectedPage + 1);
    };

    useEffect(() => {
        dispatch(getPayoutListAction(page, limit, tab))
    }, [dispatch, page, tab])


    const copyLink = async () => {
        setPaymentLinkModal(true)
    };


    return (
        <div>
            <div className='row '>
                <div className='headingheader'>
                    <h6 className='cashHeaderText cashDarkText m-0'>Payout</h6>
                    <div className='filterSection'>
                        {/* <div className='filterbtn'>
                            <div>
                                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3 4.22852H9M1.5 1.22852H10.5M4.5 7.22852H7.5" stroke="#344054" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            Filters
                        </div> */}
                        <div>
                            <button onClick={copyLink} type="button" className='customFilterButton'>
                                Create payout
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`innertableSection ${payoutList?.length > 0 ? "" : "empty"}`}>
                <div className='tabClassrow'>
                    <div className={`tabClass ${tab === 'estimated' && 'tabClassActive'}  col-4`} onClick={() => { setTab('estimated'); setPage(1); setActivePage(0); }}>
                        Estimated
                    </div>
                    <div className={`tabClass ${tab === 'upcoming' && 'tabClassActive'}  col-4`} onClick={() => { setTab('upcoming'); setPage(1); setActivePage(0); }}>
                        Upcoming
                    </div>
                    <div className={`tabClass ${tab === 'confirmed' && 'tabClassActive'}  col-4`} onClick={() => { setTab('confirmed'); setPage(1); setActivePage(0); }}>
                        Confirmed
                    </div>
                </div>
                {payoutList?.length > 0 ? payoutList?.map((item) => (
                    <div key={item?._id}>
                        <div className='tabletext' onClick={() => toggleRow(item._id)}
                            style={{ cursor: "pointer" }}>
                            <div className='tabletextCommon col-4'>{item?.plan.name}</div>
                            <div className='tabletextCommon col-4'>
                                <Currency currency={item?.currency?.value} />
                                <CurrencyFormat currency={item?.currency?.value} value={item?.convertedAmount} decimal={2} /></div>
                            <div className='col-4 stausRow'>
                                <div className={`statusClass ${item.status === "upcoming" ? "failed" : item.status === "estimated" ? "pending" : item?.status.toLowerCase()}`}>
                                    {item.status === "upcoming" ? "In progress" : item.status === "estimated" ? "Pending" : "Paid"}
                                </div>
                                <div className={`arrowIcon ${expandedRow === item?._id ? "rotate" : ""}`}>
                                    <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1 1.72852L6 6.72852L11 1.72852" stroke="black" strokeOpacity="0.5" strokeWidth="1.66667" strokeLinecap="round"
                                            strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            {/* Expanded section */}
                        </div>
                        {expandedRow === item._id && (
                            <div className='mt-2'>
                                <PlanSummary planPreview={item} isKimbocorp={item?.plan?.type == "kimbocorp"} values={item} pageType={true} />
                            </div>
                        )}
                    </div>
                )) :
                    <div className=''>
                        <div className="text-center rankings-card">
                            <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M10 24.6797V29.131H13.5714H17.1429V27.4932V25.8555L15.4303 25.8163L13.7177 25.7773L13.3974 25.379C12.9918 24.8749 12.9919 24.4844 13.3976 23.9805L13.7182 23.5822L39.3591 23.5464C57.5053 23.5211 65.1202 23.5492 65.4114 23.6425C65.8206 23.7738 66.1538 24.2394 66.1538 24.6797C66.1538 25.0277 65.8477 25.5433 65.5525 25.6925C65.3715 25.7841 64.6727 25.8383 63.673 25.8383H62.0815L62.1122 27.4541L62.1429 29.07L66.0714 29.1021L70 29.134V24.6813V20.2285H40H10V24.6797ZM19.1209 43.0334V60.2285H39.6154H60.1099V43.0334V25.8383H59.1209H58.1319V37.7379V49.6375L57.8107 49.994C57.5526 50.2803 57.394 50.3505 57.0041 50.3505C56.3345 50.3505 54.9278 50.7672 54.2835 51.1562C53.5429 51.6036 52.6234 52.5406 52.1742 53.3058C51.5913 54.2988 51.3159 55.1478 51.1815 56.3666C51.0759 57.323 51.0146 57.533 50.7573 57.82L50.4565 58.1553H39.6154H28.7743L28.4531 57.7989C28.1951 57.5125 28.1319 57.3364 28.1319 56.9038C28.1319 56.1571 27.757 54.6035 27.3944 53.8474C27.0052 53.0361 25.7119 51.6008 24.9808 51.1689C24.2994 50.7664 22.8996 50.3505 22.2267 50.3505C21.8368 50.3505 21.6781 50.2803 21.4201 49.994L21.0989 49.6375V37.7379V25.8383H20.1099H19.1209V43.0334ZM23.1038 37.0218L23.1319 48.2053L23.8068 48.3569C26.7788 49.0245 29.3258 51.8471 29.926 55.1383L30.0648 55.8993H39.6054H49.1458L49.3546 54.9846C50.0981 51.7271 52.3963 49.1612 55.2364 48.4175L56.0989 48.1917L56.1269 37.015L56.1549 25.8383H52.4718H48.7885L49.0836 26.3566C50.2611 28.4241 50.8279 31.3595 50.5496 33.948C49.929 39.7184 45.886 44.1396 40.6887 44.7316C38.6415 44.9646 36.6832 44.5633 34.7754 43.5195C29.2435 40.4928 27.0468 33.0685 29.8794 26.9721L30.4062 25.8383H26.741H23.0758L23.1038 37.0218ZM32.4731 26.5395C31.7791 27.5181 31.1476 28.996 30.8704 30.2895C30.5584 31.7457 30.6129 34.1021 30.9889 35.4114C31.9509 38.7613 34.1226 41.1572 37.1429 42.2C37.8596 42.4475 38.1891 42.4841 39.6703 42.4812C41.3047 42.478 41.4159 42.4617 42.4176 42.0786C43.7799 41.5578 44.7806 40.889 45.7898 39.8252C47.8311 37.6733 48.8707 34.6368 48.5803 31.6746C48.3833 29.6644 47.6501 27.6453 46.6491 26.3566L46.2466 25.8383H43.453H40.6593V26.448V27.0578H41.3271C41.9187 27.0578 42.0316 27.0985 42.3162 27.4142C42.5354 27.6575 42.6374 27.8929 42.6374 28.1553C42.6374 28.4178 42.5354 28.6531 42.3162 28.8964C41.9979 29.2495 41.9829 29.2529 40.7173 29.2529C38.9926 29.2529 38.6813 29.4324 38.6813 30.4269C38.6813 31.0541 39.0401 31.3896 39.8196 31.4912C41.8307 31.7535 43.0888 33.8368 42.4643 35.8707C42.2587 36.5403 41.6068 37.4007 41.0552 37.7303C40.6704 37.9603 40.6593 37.9867 40.6593 38.6769C40.6593 39.7733 40.2992 40.3505 39.6154 40.3505C38.9573 40.3505 38.5714 39.7434 38.5714 38.708V38.1553H38.0165C37.3336 38.1553 36.8857 37.9124 36.7124 37.4481C36.5422 36.9922 36.6563 36.5068 37.0052 36.2022C37.2448 35.9929 37.4521 35.9602 38.5368 35.9602C39.9515 35.9602 40.3263 35.8263 40.544 35.2433C40.8304 34.4757 40.3797 33.8303 39.4698 33.7051C38.256 33.5381 37.4401 32.9325 36.9564 31.8392C36.7092 31.2808 36.6503 30.9863 36.6581 30.3505C36.6636 29.9145 36.7464 29.3553 36.8421 29.1078C37.0648 28.5322 37.8245 27.6155 38.2353 27.4267C38.5277 27.2922 38.5558 27.2234 38.5897 26.5592L38.6264 25.8378L35.7984 25.838L32.9702 25.8383L32.4731 26.5395Z" fill="#2978B5" />
                            </svg>
                            <p className="m-0">
                                Set up your payout now to receive rewards for your efforts. Help others, grow your influence, and get paid — don’t miss your chance to turn your impact into income!
                            </p>
                        </div>
                    </div>
                }
            </div>
            {payoutListCount > 0 &&
                <div className="py-3 d-flex align-items-center justify-content-end px-3">
                    <ReactPaginate
                        previousLabel={<i className="fas fa-chevron-left"></i>} // Font Awesome icon for previous
                        nextLabel={<i className="fas fa-chevron-right"></i>} // Font Awesome icon for next
                        pageCount={payoutListCount}
                        marginPagesDisplayed={1}
                        pageRangeDisplayed={2}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination customPagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                        forcePage={activePage}
                    />
                </div>
            }
            <CreatePayment show={paymentLinkModal} onClose={() => setPaymentLinkModal(false)} conversation={null} isChatPage={false} />

        </div>
    )
}
